import { Component, Inject } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { NOTIFY } from 'src/app/core/constants/notification.constants';
import { AttestationService } from 'src/app/core/services/attestation.service';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'app-attestation',
  templateUrl: './attestation.component.html',
  styleUrls: ['./attestation.component.scss']
})
export class AttestationComponent {
  action: 'add' | 'edit' = 'add';
  rowData: any = null;

  userForm: FormGroup = new FormGroup({});
  formFields = [
    {
      name: 'approach', label: 'Approach', type: 'select', space: 2,
      validators: [Validators.required],
      options: this.attestationService.approaches.map((i: any) => ({ label: i, value: i }))
    },
    {
      name: 'artifactKey', label: 'Artifact Type', type: 'select', space: 2,
      validators: [Validators.required],
      options: []
    },
    { name: 'title', label: 'Title', type: 'text', space: 1, validators: [Validators.required] }
  ];
  submitting = false;

  html = '';
  pdf = '';

  quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['blockquote', 'code-block'],
      ['link'],
      [{ align: [] }],
      ['clean'],
    ],
  };

  constructor(
    public dialogRef: MatDialogRef<AttestationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public attestationService: AttestationService,
    private utilService: UtilService
  ) {
    this.action = data?.action || 'add';
    this.rowData = data?.data || null;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.action === 'edit' && this.rowData) {
        this.formFields[1].options = this.artifactKeys();
        this.userForm.patchValue(this.rowData);
        this.userForm.get('approach')?.disable();
        this.userForm.get('artifactKey')?.disable();
        this.html = this.rowData.html;
        this.pdf = this.rowData.pdf;
      }

      this.userForm.valueChanges.subscribe((val) => {
        if (val.approach) {
          this.formFields[1].options = this.artifactKeys();
        }
      });
    });
  }

  async submit() {
    if (!this.userForm.valid) return;
    if (!this.html) {
      this.utilService.openToastr('error', 'HTML content can not be empty');
      return;
    };
    if (!this.pdf) {
      this.utilService.openToastr('error', 'PDF content can not be empty');
      return;
    };


    this.submitting = true;
    const cleanHtml = this.sanitizeBody(this.html);
    const cleanPdf = this.sanitizeBody(this.pdf);
    forkJoin({
      html: this.addEdit({ ...this.userForm.getRawValue(), formatType: "html", body: cleanHtml }),
      pdf: this.addEdit({ ...this.userForm.getRawValue(), formatType: "pdf", body: cleanPdf }),
    }).subscribe({
      next: () => {
        this.utilService.openToastr('success', NOTIFY.ATTESTATION[this.action].SUCCESS);
        this.dialogRef.close(true);
      },
      error: () => {
        this.utilService.openToastr('error', NOTIFY.ATTESTATION[this.action].ERROR);
        this.submitting = false;
      }
    })
  }

  addEdit(payload: any) {
    if (this.action === 'add') {
      return this.attestationService.createContent(payload)
    } else {
      return this.attestationService.updateContent(payload)
    }
  }

  sanitizeBody(body: string): string {
    if (!body) return body;
    return body.replace(/&nbsp;/g, ' ');
  }

  artifactKeys() {
    return this.attestationService.artifactKeys.map((i: any) => {
      return { label: i.name, value: i.key, disabled: this.attestationService.artifactKeysByApproch[this.userForm.get('approach')?.value]?.includes(i.key) }
    });
  }
}
